import React from 'react'
import { Link } from 'react-router-dom'
import Icon from './icons'
import PortalIllustration from './PortalIllustration'

// Ported from the source project's src/components/site/Portal.tsx. Per-feature Reveal
// dropped for the same reason as Services.jsx/Process.jsx - this repo's Reveal
// only takes a `delay` prop (no `index`/`className`), and the page wraps whole sections in
// Reveal, not each card.
//
// The CTAs are <Link>s, not the source's dead <button>s, matching Task 4's Hero CTA
// precedent of making marketing CTAs actually navigate: "Access portal" -> /login (an
// existing client signing in), "Request account access" -> /contant (the only route in
// the app that accepts an enquiry).
const Portal = ({ section, features }) => {
    const c = section.content ?? {};
    const primaryCta = c.primaryCta ?? 'Access portal';
    const secondaryCta = c.secondaryCta ?? 'Request account access';

    return (
        <section className="section portal-section" id="portal">
            <div className="container">
                <div className="portal-inner">
                    <div>
                        <div className="section-eyebrow">{section.eyebrow}</div>
                        <h2 className="section-title">{section.title}</h2>
                        <p className="section-sub">{section.subtitle}</p>
                        <div className="portal-features">
                            {features.map((f) => (
                                <div className="portal-feature" key={f.order}>
                                    <div className="pf-icon">
                                        <Icon name={f.icon} />
                                    </div>
                                    <div>
                                        <div className="pf-title">{f.title}</div>
                                        <div className="pf-desc">{f.description}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: 32, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                            <Link className="btn-lg" to="/login">{primaryCta}</Link>
                            <Link className="btn-lg-outline-white" to="/contant">{secondaryCta}</Link>
                        </div>
                    </div>

                    {c.illustration && <PortalIllustration block={c.illustration} />}
                </div>
            </div>
        </section>
    );
};

export default Portal;
